export default "__VITE_ASSET__CpmNjVmi__"